import { render } from "./MainScreenComponent.vue?vue&type=template&id=7704fbef"
import script from "./MainScreenComponent.vue?vue&type=script&lang=js"
export * from "./MainScreenComponent.vue?vue&type=script&lang=js"

import "./MainScreenComponent.vue?vue&type=style&index=0&id=7704fbef&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__